"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _Input = _interopRequireDefault(require("../Forms/Input"));

var _FormWrapper = _interopRequireDefault(require("../Forms/FormWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Components
const SearchWrapper = _styledComponents.default.div.withConfig({
  displayName: "Searchbox__SearchWrapper",
  componentId: "design-system__sc-10doncf-0"
})(["align-self:center;display:flex;width:100%;& input[type=\"text\"]{width:22ch;}"]);

const Searchbox = _ref => {
  let {
    placeholder,
    path,
    value
  } = _ref;
  const [searchInput, setSearchInput] = (0, _react.useState)(value);

  const handleInputChange = event => {
    event.persist();
    setSearchInput(event.target.value);
  };

  const handleSubmit = event => {
    event.preventDefault();
    window.location.href = path + searchInput;
  };

  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit,
    style: {
      alignSelf: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_FormWrapper.default, null, /*#__PURE__*/_react.default.createElement(SearchWrapper, null, /*#__PURE__*/_react.default.createElement(_Input.default, {
    name: "search",
    type: "text",
    endIcon: "search",
    value: searchInput,
    placeholder: placeholder,
    onChange: e => handleInputChange(e)
  }))));
};

Searchbox.propTypes = {
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  path: _propTypes.default.string.isRequired
};
Searchbox.defaultProps = {
  placeholder: '',
  value: ''
};

var _default = (0, _reactRouterDom.withRouter)(Searchbox);

exports.default = _default;